import * as Sentry from '@sentry/browser'
import { kAgentV2MatterApiBasePath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { getResponseDebugContext, getTopLevelKeys } from '@/util/api/response-body'
import { ApiResponsePayloadError } from '@/util/errors/api-response-payload-error'
import { AgentV2ConversationSurface, AgentV2CreateConversationResponse, AgentV2CreateConversationResponseSchema } from '@/agent-v2/store/schemas'
import { agentV2Request } from './agent-v2-request'

export async function postCreateAgentV2Conversation(matterId: string, originSurface: AgentV2ConversationSurface): Promise<AgentV2CreateConversationResponse> {
  const url = `${kPaxtonAppApiRESTBaseUrl()}${kAgentV2MatterApiBasePath}${matterId}/conversations`
  return agentV2Request({
    url,
    method: 'POST',
    body: JSON.stringify({ origin_surface: originSurface }),
    sentryEndpoint: 'POST /api/v2/matter/{matter_id}/conversations',
    parseResponse: (data, { response, sentryTags }) => {
      const parsed = AgentV2CreateConversationResponseSchema.safeParse(data)
      if (parsed.success) return parsed.data

      Sentry.withScope((scope) => {
        scope.setTags(sentryTags)
        Sentry.captureException(new Error('Agent v2 create conversation response schema validation failed'), {
          extra: {
            ...getResponseDebugContext(response, url),
            matterId,
            responseKeys: getTopLevelKeys(data),
            issues: parsed.error.issues,
          },
        })
      })
      throw new ApiResponsePayloadError(response.status, 'Invalid Agent v2 create conversation response shape', parsed.error.issues)
    },
  })
}
